module.exports = __webpack_public_path__ + "static/img/img_7.cf92fd7b.jpg";